import axios from "axios";


const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    timeout: 10 * 60 * 1000, // 10 minutes
    headers: {
        "ngrok-skip-browser-warning": "69420",
    },

});

axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("accessToken");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export const aiClinicalDecisionApi = async (data) => {
    try {
        const config = {};

        // Set Content-Type for FormData
        if (data instanceof FormData) {
            config.headers = {
                'Content-Type': 'multipart/form-data',
            };
        }

        const response = await axiosInstance.post(
            "/api/v1/clinical_decision/analyze_case",
            data,
            config
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
    }
};




const handleApiError = (error) => {
    if (error.response) {
        throw new Error(error.response.data.message || "An error occurred");
    } else {
        throw new Error("Network error or server not reachable");
    }
};

// Get reports history with pagination
export const getClinicalDecisionReports = async (page = 1, perPage = 10) => {
    try {
        const response = await axiosInstance.get(
            "/api/v1/clinical_decision/reports",
            {
                params: {
                    page,
                    per_page: perPage,
                },
            }
        );
        // Backend returns an array directly
        return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
        handleApiError(error);
    }
};

// Get single report by ID
export const getClinicalDecisionReport = async (reportId) => {
    try {
        const response = await axiosInstance.get(
            `/api/v1/clinical_decision/reports/${reportId}`
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
    }
};

// Download report PDF
export const downloadClinicalDecisionReport = async (reportId) => {
    try {
        const response = await axiosInstance.get(
            `/api/v1/clinical_decision/reports/${reportId}`,
            {
                responseType: 'blob', // Important for PDF download
            }
        );
        return response.data;
    } catch (error) {
        handleApiError(error);
    }
};
